import { Reveal } from "./Reveal";
import { PROCESS } from "@/lib/site";

export default function Process() {
  return (
    <section id="process" className="dotgrid bg-navy py-20 md:py-28">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8">
        <Reveal>
          <p className="eyebrow !text-[#e8a33d]">Our process</p>
          <h2 className="mt-4 font-display text-4xl font-light leading-[1.12] text-white md:text-5xl">
            Three steps. <em className="italic">Zero hassle.</em>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-12 md:mt-20 md:grid-cols-3 md:gap-10">
          {PROCESS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.1}>
              <div className="relative">
                <span className="ghost-num" aria-hidden="true">{p.n}</span>
                <div className="relative">
                  <div className="numbox">{p.n}</div>
                  {i < 2 && (
                    <div className="absolute left-[130px] right-[-40px] top-[52px] hidden h-px bg-white/10 md:block" aria-hidden="true" />
                  )}
                  <h3 className="mt-8 font-display text-xl font-medium text-white md:text-2xl">{p.title}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-white/60">{p.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
